<template>
    <div class="fm-properties-wrapper">
        <div class="row">
            <div class="label label-size">Size:</div>
            <div class="datum datum-size">{{ bytesToHuman(selectedItem.size) }}</div>
        </div>
        <div class="row">
            <div class="label label-type">File Type:</div>
            <div class="datum datum-type">{{ selectedItem.extension }}</div>
        </div>
        <div class="row">
            <div class="label label-date">Date:</div>
            <div class="datum datum-date">{{ timestampToDate(selectedItem.timestamp) }}</div>
        </div>
    </div>
</template>

<script>
import modal from './../mixins/modal';
import translate from './../../../mixins/translate';
import helper from './../../../mixins/helper';
import EventBus from './../../../eventBus';

export default {
  name: 'Properties',
  mixins: [modal, translate, helper],
  data() {
    return {
      url: null,
    };
  },
  computed: {
    /**
             * Selected disk
             * @returns {*}
             */
    selectedDisk() {
      return this.$store.getters['fm/selectedDisk'];
    },

    /**
             * Selected file
             * @returns {*}
             */
    selectedItem() {
      return this.$store.getters['fm/selectedItems'][0];
    },
  },
  methods: {
    /**
             * Get URL
             */
    getUrl() {
      this.$store.dispatch('fm/url', {
        disk: this.selectedDisk,
        path: this.selectedItem.path,
      }).then((response) => {
        if (response.data.result.status === 'success') {
          this.url = response.data.url;
        }
      });
    },

    /**
             * Copy text to clipboard
             * @param text
             */
    copyToClipboard(text) {
      // create input
      const copyInputHelper = document.createElement('input');
      copyInputHelper.className = 'copyInputHelper';
      document.body.appendChild(copyInputHelper);
      // add text
      copyInputHelper.value = text;
      copyInputHelper.select();
      // copy text to clipboard
      document.execCommand('copy');
      // clear
      document.body.removeChild(copyInputHelper);

      // Notification
      EventBus.$emit('addNotification', {
        status: 'success',
        message: this.lang.notifications.copyToClipboard,
      });
    },
  },
};
</script>

<style lang="scss">
    .fm-modal-properties .modal-body{
    .row {
        margin-bottom: 0.3rem;
        padding-top: 0.3rem;
        padding-bottom: 0.3rem;

    .fa-copy {
        padding-top: 0.2rem;
        display: none;
        cursor: pointer;
    }

    &:hover {
         background-color: #f8f9fa;

    & .fa-copy {
          display: block;
      }
    }
    }

    .col-2 {
        font-weight: bold;
    }

    .col-9 {
        word-wrap: break-word;
    }
    }
</style>
